import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, PRIMARY_OUTLET } from '@angular/router';
import { AuthService } from '../_services/auth.service';
import { FunctionalityCode } from 'src/app/core/_enums/functionality.code';

@Injectable({ providedIn: 'root' })
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router
  ) {}

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const user = this.authService.userValue;
    const userRole = localStorage.getItem('userRole');

    var userRoleJSON = JSON.parse(userRole ? userRole : '{}');

    const userRight = localStorage.getItem('userRight');

    var userRightJSON = JSON.parse(userRight ? userRight : '{}');

    if (state.url != '/' && this.AllowsDisplayPage(userRoleJSON.profileCode, state, userRightJSON) == false) {
      // Une page hors des droits du profil renvoie à l'accueil ; la session, elle, reste valide.
      this.router.navigate(['/']);
      return false;
    }

    if (user.expires) {
      const userExpiresGMT = user.expires.replace('T', ' ') + ' GMT';
      var userExpires = new Date(userExpiresGMT).toUTCString();
      if (userExpires == 'Invalid Date') userExpires = new Date(user.expires).toString();

      const dateNow = new Date().toUTCString();

      if (user?.key?.length !== 0 && Date.parse(userExpires) > Date.parse(dateNow)) {
        // Retourne vrai si le token de l'utilisateur n'a pas expiré.
        return true;
      }
    }

    // Déconnexion et redirection vers la page de connexion avec l'URL de retour.
    this.authService.logout();
    return false;
  }

  AllowsDisplayPage(roleCode: string, state: RouterStateSnapshot, listAccesses: string[]): boolean {
    var currentRootPath: string;
    const tree = this.router.parseUrl(state.url);
    const children = tree.root.children[PRIMARY_OUTLET];

    if (children.segments != null && children.segments.length > 0) currentRootPath = children.segments[0].path;
    else currentRootPath = '';

    var returnFlag: boolean;
    returnFlag = true;

    if (currentRootPath == 'project' && !listAccesses.includes(FunctionalityCode.ProjectView)) {
      returnFlag = false;
    } else if (currentRootPath == 'product-formula' && !listAccesses.includes(FunctionalityCode.ProductView)) {
      returnFlag = false;
    } else if (currentRootPath == 'engin-atelier' && !listAccesses.includes(FunctionalityCode.DeviceView)) {
      returnFlag = false;
    } else if (currentRootPath == 'acheminement' && !listAccesses.includes(FunctionalityCode.TransportationView)) {
      returnFlag = false;
    } else if (currentRootPath == 'transport' && !listAccesses.includes(FunctionalityCode.TransportView)) {
      returnFlag = false;
    } else if (currentRootPath == 'energy' && !listAccesses.includes(FunctionalityCode.EnergyView)) {
      returnFlag = false;
    } else if (currentRootPath == 'industrie' && !listAccesses.includes(FunctionalityCode.IndustryView)) {
      returnFlag = false;
    } else if (currentRootPath == 'combustible' && !listAccesses.includes(FunctionalityCode.CombustibleView)) {
      returnFlag = false;
    } else if (currentRootPath == 'member' && !listAccesses.includes(FunctionalityCode.MemberView)) {
      returnFlag = false;
    } else if (currentRootPath == 'user-entity' && !listAccesses.includes(FunctionalityCode.UEView)) {
      returnFlag = false;
    } else if (currentRootPath == 'agency' && !listAccesses.includes(FunctionalityCode.AgencyView)) {
      returnFlag = false;
    } else if (currentRootPath == 'user' && !listAccesses.includes(FunctionalityCode.UserView)) {
      returnFlag = false;
    } else if (currentRootPath == 'statisticProfile' && !listAccesses.includes(FunctionalityCode.ACEUView) && !listAccesses.includes(FunctionalityCode.ABEView)) {
      returnFlag = false;
    } else if (currentRootPath == 'statistic' && !listAccesses.includes(FunctionalityCode.StatisticView) && !listAccesses.includes(FunctionalityCode.ACDView)) {
      returnFlag = false;
    } else if (currentRootPath == 'administration' && !listAccesses.includes(FunctionalityCode.AdministrationView)) {
      returnFlag = false;
    } else if (currentRootPath == 'email' && !listAccesses.includes(FunctionalityCode.ACUView)) {
      returnFlag = false;
    } else if (currentRootPath == 'partner-api' && !listAccesses.includes(FunctionalityCode.PartnerApiProjects)) {
      returnFlag = false;
    }

    return returnFlag;
  }
}
